import React from 'react';
import styled from 'styled-components';
import { Skeleton as AntdSkeleton } from 'antd';
import { AvatarProps as AntdSkeletonAvatarProps } from 'antd/lib/skeleton/Avatar';

type SkeletonAvatarProps = Omit<AntdSkeletonAvatarProps, 'active'>;

const SkeletonAvatar = styled(({ ...props }: SkeletonAvatarProps) => <AntdSkeleton.Avatar {...props} active />)``;

export default SkeletonAvatar;
